import "./Drawer.css";

type CustomDrawerProps = {
  children: JSX.Element;
  anchor?: "left" | "right";
  isOpen: boolean;
  onClose: () => void;
};

function Drawer({
  children,
  anchor = "right",
  isOpen,
  onClose,
}: CustomDrawerProps) {
  return (
    <div>
      <div className={`drawer ${anchor} ${isOpen ? "open" : ""}`}>
        <div className="drawer-content">{children}</div>
      </div>
      {isOpen && <div className="drawer-overlay" onClick={onClose} />}
    </div>
  );
}

export default Drawer;
